import React from "react";
import AndroidInstallBanner from "./InstallBanner/AndroidInstallBanner";
import IOSInstallBanner from "./InstallBanner/IOSInstallBanner";
import DesktopInstallBanner from "./InstallBanner/DesktopInstallBanner";
import UserAgent from "../Utils/UserAgent";

const InstallBanner = () => {
    if (UserAgent.isIOS())
        return <IOSInstallBanner />;
    if (UserAgent.isDesktop())
        return <DesktopInstallBanner />;
    if (UserAgent.isAndroid())
        return <AndroidInstallBanner />;

    return null;
};

export default InstallBanner;
